import React from 'react'
import { Box, Typography, Skeleton, Tooltip } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { intelColors, kpiBorderColor } from './intelTheme'

export default function KpiCard({ label, value, sub, color = 'blue', subColor, valueSize = 26, loading, info }) {
  return (
    <Box
      sx={{
        background: intelColors.surfaceBg,
        borderRadius: '8px',
        padding: '16px',
        border: `1px solid ${intelColors.border}`,
        borderLeft: `4px solid ${kpiBorderColor[color] || intelColors.primary}`,
        minHeight: 90,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', mb: '6px' }}>
        <Typography
          sx={{
            fontSize: 11,
            color: '#888',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            fontWeight: 600,
          }}
        >
          {label}
        </Typography>
        {info ? (
          <Tooltip title={info} arrow placement='top'>
            <InfoOutlinedIcon sx={{ fontSize: 13, color: '#b0b0b0', cursor: 'help' }} />
          </Tooltip>
        ) : null}
      </Box>
      <Typography sx={{ fontSize: valueSize, fontWeight: 700, color: intelColors.text, lineHeight: 1.1 }}>
        {loading ? <Skeleton variant='text' animation='wave' width='60%' sx={{ fontSize: valueSize }} /> : value}
      </Typography>
      {loading ? (
        <Skeleton variant='text' animation='wave' width='40%' sx={{ fontSize: 11, mt: '4px' }} />
      ) : (
        sub && <Typography sx={{ fontSize: 11, color: subColor || '#888', mt: '4px' }}>{sub}</Typography>
      )}
    </Box>
  )
}
